import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import MatchdaySlider from '../MatchdaySlider';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class CopaChile2013 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);

    this.state = {
	showCards: true,
      path: this.props.path,
	kit_path: '/images/kits/todas/',
      kits: [],
	maxMatchday: 6,
	color2:['#295e1e','#295e1e',0,0],
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: [753,754,755,756,757,758,765,770],
     table2: []  
    /*table1:[{'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':6, 'pg':2,'pe':4,'pp':0,'gf':7,'gc':3,'dif':4, 'pts':10},
	      {'color':0,'shortname':'lota', 'rivalName':'Lota Schwager', 'pj':6, 'pg':0,'pe':5,'pp':1,'gf':4,'gc':5,'dif':-1, 'pts':5},
	      {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':6, 'pg':2,'pe':4,'pp':0,'gf':5,'gc':3,'dif':2, 'pts':10},
	      {'color':0,'shortname':'naval', 'rivalName':'Naval', 'pj':6, 'pg':0,'pe':3,'pp':3,'gf':4,'gc':9,'dif':-5, 'pts':3}]
*/

    };
  }

  componentDidMount() {
	this.getKits();
	this.getStandings();
	}




generateTable(fixture, json){

let result = [];
const lastTable = json[fixture].table;
console.log(lastTable);
lastTable.forEach(team => {
  console.log(team.team, team.points);
  result.push({
    shortname: team.name,
    pj: team.played,
    pg: team.won,
    pe: team.drawn,
    pp: team.lost,
    gf: team.goals_for,
    gc: team.goals_against,
    dif: team.goal_difference,
    pts: team.points,
    rivalName: team.team
  });
});

return result;



}

handleMatchdayChange = (day) => {
    console.log("Selected matchday:", day);



        let newtable2 = this.generateTable(day-1,this.state.standings);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});


  };


getStandings(){

        fetch("https://www.registrosudec.com:5000/standings", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: 39
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)

        let standingsObj = result['standings'];
        let regular = standingsObj[0];
        console.log("regular");
        console.log(regular);
        this.setState({ 
        standings: regular['standings_history']}) //[json1, json2,...]
        let newtable2 = this.generateTable(5,regular['standings_history']);

        let sortednewtable2 = this.sortTable(newtable2);


        for (let i = 0; i < sortednewtable2.length; i++) {
                sortednewtable2[i].color = this.state.color2[i]; 
        }
        this.setState({table2:sortednewtable2});



    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a 8° de Final');
  return(

	<div style={{textAlign: 'center' }}>
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Copa Chile 2013-14</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

	   <div style={{ height: '50px' }}></div>
        <div>
        <span>Evolución de la tabla</span>
      <MatchdaySlider maxMatchday={this.state.maxMatchday} onChange={this.handleMatchdayChange} />
    </div>


      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo 3 </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Copa Chile 2013-14</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Copa Chile 2013-14</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Copa Chile 2013-14" />
     </div>


  )
}

}
export default CopaChile2013;
